// extracted by mini-css-extract-plugin
module.exports = {"msg":"resend-claim-modal_msg_2ywXt","subicon":"resend-claim-modal_subicon_1Q-zD"};